import React from 'react';
import {Show, SimpleShowLayout, TextField} from 'react-admin';

class CashbackConditionItemsShow extends React.Component {
    render() {
        return (
            <Show {...this.props}>
                <SimpleShowLayout>
                    <TextField source="id" addLabel={true} />
                    <TextField source="cashbackId" label="Cashback Block" />
                    <TextField source="position" addLabel={true} />
                    <TextField source="type" addLabel={true} />
                    <TextField source="text" addLabel={true} />
                    <TextField source="url" addLabel={true} />
                    <TextField source="textColor" label="Text Color" />
                    <TextField source="textFont" label="Font Size" />
                    <TextField source="textMargin" label="Text Margin" />
                    <TextField source="imageMargin" label="Image Margin" />
                </SimpleShowLayout>
            </Show>
        );
    }
}

export default CashbackConditionItemsShow;
